<template>
  <div class="actions">
    <DomFade
      v-if="notInstalled && notInstalled.length"
      key="not-installed"
      class="div"
      :delay="200 + 100"
    >
      <ButtonBase
        class="button"
        stroke="n"
        theme="secondary"
        size="small"
        rounded
        :disabled="
          loading ||
          (notInstalled.length === 1 &&
            isContentInUserLibsButNotAsChild(notInstalled[0].id))
        "
        @click="select"
      >
        {{ $t('library.subscriber.button.add') }}
      </ButtonBase>
    </DomFade>
  </div>
</template>
<script setup lang="ts">
import type { LibraryBookSchema } from '~/types/schema';

interface Props {
  children: LibraryBookSchema[];
  showWarning?: boolean;
  autoRedirect?: boolean;
}

const props = defineProps({
  children: null,
  showWarning: { type: Boolean, default: true },
  autoRedirect: { type: Boolean, default: false }
});

const profile = useProfileStore();

const { isContentInUserLibsButNotAsChild, isDownloadableContent } =
  useContentsHelper();

const notInstalled = computed(() =>
  props.children.filter(
    (child) => !child.isAdventure // TODO when bug fixed in ADAM
  )
);

const { loading, select } = useLibraryDialogAdd(
  notInstalled.value,
  profile.needToDefineMainContent,
  props.autoRedirect
);
</script>
<style lang="scss" scoped>
.actions,
.buttons {
  display: flex;
  flex-direction: column;
  gap: var(--gap_m);
  align-items: center;
}

.button {
  width: fit-content;
}

.adventure-warning {
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 0.4rem 0.8rem;
  border-radius: 4rem;
  gap: 0.6rem;
}
</style>
